export { relatoriosLexReducer } from './slice';
